<mat-card>
  <!-- Header -->
  <app-card-header
    [title]="title"
    icono="note"
    [draggable]="true"
  ></app-card-header>

  @if (this.form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content class="card-content-crear" style="max-height: 65vh">
        <!-- Sección: Vigencia -->
        <div class="form-section">
          <app-section-title
            icon="date_range"
            title="Vigencia"
          ></app-section-title>

          <section class="column-center" style="width: 100%; gap: 16px">
            <!-- Permanente -->
            <div
              style="width: 100%; display: flex; align-items: center; gap: 8px"
            >
              <mat-checkbox
                color="primary"
                formControlName="permanente"
              ></mat-checkbox>
              <div>
                <strong>Permanente</strong>
                <div style="font-size: 12px; color: #666">
                  La nota/contacto estará vigente indefinidamente
                </div>
              </div>
            </div>

            @if (!form?.value?.permanente) {
              <div style="width: 100%; display: flex; gap: 16px">
                <!-- Desde -->
                <mat-form-field style="flex: 1">
                  <mat-label>Desde</mat-label>
                  <input
                    matInput
                    [owlDateTime]="dt1"
                    formControlName="vigenciaDesde"
                    [disabled]="true"
                  />
                  <button
                    irxBotonIcono
                    tooltip="Elegir fecha"
                    matSuffix
                    [owlDateTimeTrigger]="dt1"
                    type="button"
                  >
                    <mat-icon>event</mat-icon>
                  </button>
                  <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                </mat-form-field>

                <!-- Hasta -->
                <mat-form-field style="flex: 1">
                  <mat-label>Hasta</mat-label>
                  <input
                    matInput
                    [owlDateTime]="dt2"
                    formControlName="vigenciaHasta"
                    [disabled]="true"
                  />
                  <button
                    irxBotonIcono
                    tooltip="Elegir fecha"
                    matSuffix
                    [owlDateTimeTrigger]="dt2"
                    type="button"
                  >
                    <mat-icon>event</mat-icon>
                  </button>
                  <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
                </mat-form-field>
              </div>
            }
          </section>
        </div>

        @if (form?.value?.tipo === 'Nota' || form?.value?.tipo === 'Contacto') {
          <!-- Sección: Categoría de Evento -->
          <div class="form-section">
            <app-section-title
              icon="category"
              title="Categoría de Evento"
            ></app-section-title>

            <section
              class="column-center"
              style="width: 100%; gap: 8px; padding: 0 16px"
            >
              <ng-select
                [items]="categoriasEvento"
                bindLabel="nombre"
                bindValue="_id"
                formControlName="idCategoriaEvento"
                placeholder="Todos los eventos"
                [notFoundText]="'No hay categorías creadas'"
                style="width: 100%"
                [multiple]="false"
                [searchable]="true"
                [clearable]="true"
                appendTo="body"
              ></ng-select>
              <div style="font-size: 12px; color: #666">
                Si no se selecciona una categoría, esta nota/contacto se
                mostrará para eventos de cualquier categoría
              </div>

              <mat-form-field
                style="width: 100%; margin-top: 8px"
                [formGroup]="informacion"
              >
                <mat-label>Partición</mat-label>
                <input matInput type="number" formControlName="particion" />
                <mat-icon matPrefix>grid_view</mat-icon>
                <mat-hint>
                  Si no se indica una partición, esta nota/contacto se mostrará
                  para eventos de cualquier partición de la alarma
                </mat-hint>
              </mat-form-field>
            </section>
          </div>
        }

        <!-- Sección: Período de Inhabilitación (solo contactos permanentes) -->
        @if (form?.value?.permanente && form?.value?.tipo === 'Contacto') {
          <div class="form-section">
            <app-section-title
              icon="date_range"
              title="Período sin actividad"
            ></app-section-title>

            <section class="column-center" style="width: 100%; gap: 16px">
              <div style="font-size: 12px; color: #666; text-align: center">
                Durante este período, el contacto no se mostrará al tratar
                eventos
              </div>
              <div style="width: 100%; display: flex; gap: 16px">
                <!-- Desde -->
                <mat-form-field style="flex: 1">
                  <mat-label>Desde</mat-label>
                  <input
                    matInput
                    [owlDateTime]="dtInh1"
                    formControlName="inhabilitadoDesde"
                    [disabled]="true"
                  />
                  <button
                    irxBotonIcono
                    tooltip="Elegir fecha"
                    matSuffix
                    [owlDateTimeTrigger]="dtInh1"
                    type="button"
                  >
                    <mat-icon>event</mat-icon>
                  </button>
                  <owl-date-time
                    [pickerType]="'calendar'"
                    #dtInh1
                  ></owl-date-time>
                </mat-form-field>

                <!-- Hasta -->
                <mat-form-field style="flex: 1">
                  <mat-label>Hasta</mat-label>
                  <input
                    matInput
                    [owlDateTime]="dtInh2"
                    formControlName="inhabilitadoHasta"
                    [disabled]="true"
                  />
                  <button
                    irxBotonIcono
                    tooltip="Elegir fecha"
                    matSuffix
                    [owlDateTimeTrigger]="dtInh2"
                    type="button"
                  >
                    <mat-icon>event</mat-icon>
                  </button>
                  <owl-date-time
                    [pickerType]="'calendar'"
                    #dtInh2
                  ></owl-date-time>
                </mat-form-field>
              </div>
            </section>
          </div>
        }

        @if (form?.value?.tipo === 'Contacto') {
          <!-- Sección: Información de Contacto -->
          <div class="form-section">
            <app-section-title
              icon="person"
              title="Información de Contacto"
            ></app-section-title>

            <section
              class="column-center"
              style="width: 100%; gap: 16px"
              [formGroup]="informacion"
            >
              <div style="width: 100%; display: flex; gap: 16px">
                <mat-form-field style="flex: 1">
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="contacto" />
                  <mat-icon matPrefix>badge</mat-icon>
                </mat-form-field>

                <mat-form-field style="flex: 1">
                  <mat-label>Teléfono</mat-label>
                  <input matInput formControlName="telefono" />
                  <mat-icon matPrefix>phone</mat-icon>
                </mat-form-field>
              </div>

              <div style="width: 100%; display: flex; gap: 16px">
                <mat-form-field style="flex: 1">
                  <mat-label>Interno</mat-label>
                  <input matInput formControlName="interno" />
                  <mat-icon matPrefix>dialpad</mat-icon>
                </mat-form-field>

                <mat-form-field style="flex: 1">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" type="email" />
                  <mat-icon matPrefix>email</mat-icon>
                </mat-form-field>
              </div>

              <mat-form-field style="width: 100%">
                <mat-label>Número de Usuario</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="numeroUsuarioAlarma"
                />
                <mat-icon matPrefix>numbers</mat-icon>
              </mat-form-field>
            </section>
          </div>

          <!-- Sección: Seguridad -->
          <!-- Sección: Seguridad -->
          <div class="form-section">
            <!-- Título original: Claves de Seguridad -->
            <app-section-title
              icon="security"
              title="Palabras de Seguridad"
            ></app-section-title>

            <!-- Claves -->
            <section class="column-center" style="width: 100%; gap: 16px">
              <div
                style="width: 100%; display: flex; gap: 16px"
                [formGroup]="informacion"
              >
                <mat-form-field style="flex: 1">
                  <mat-label>Palabra de Seguridad</mat-label>
                  <input matInput formControlName="palabraSeguridadNormal" />
                  <mat-icon matPrefix>key</mat-icon>
                </mat-form-field>

                <mat-form-field style="flex: 1">
                  <mat-label>Palabra de Seguridad de Emergencia</mat-label>
                  <input
                    matInput
                    formControlName="palabraSeguridadEmergencia"
                  />
                  <mat-icon matPrefix>emergency</mat-icon>
                </mat-form-field>
              </div>
            </section>

            <!-- Nuevo título para prioridad -->
            <app-section-title
              icon="tune"
              title="Configuración"
            ></app-section-title>

            <!-- Prioridad -->
            <section class="column-center" style="width: 100%; gap: 16px">
              <div style="width: 100%; display: flex; gap: 16px">
                <mat-form-field style="flex: 1">
                  <mat-label>Orden de prioridad</mat-label>
                  <input matInput formControlName="orden" type="number" />
                  <mat-icon matPrefix>format_list_numbered</mat-icon>
                  <mat-hint>Menor número = Mayor prioridad</mat-hint>
                </mat-form-field>
              </div>
            </section>
          </div>
        }

        @if (form?.value?.tipo === 'Nota') {
          <!-- Sección: Información de Nota -->
          <div class="form-section">
            <app-section-title
              icon="note"
              title="Información de Nota"
            ></app-section-title>

            <section class="column-center" style="width: 100%; gap: 16px">
              <mat-form-field style="width: 100%">
                <mat-label>Orden de prioridad</mat-label>
                <input matInput formControlName="orden" type="number" />
                <mat-icon matPrefix>format_list_numbered</mat-icon>
                <mat-hint>Menor número = Mayor prioridad</mat-hint>
              </mat-form-field>
            </section>
          </div>
        }

        @if (form?.value?.tipo === 'Nota' || form?.value?.tipo === 'Contacto') {
          <!-- Sección: Observaciones -->
          <div class="form-section">
            <app-section-title
              icon="notes"
              title="Observaciones"
            ></app-section-title>

            <section
              class="column-center"
              style="width: 100%; gap: 16px"
              [formGroup]="informacion"
            >
              <mat-form-field style="width: 100%">
                <mat-label>Nota</mat-label>
                <textarea
                  matInput
                  formControlName="nota"
                  style="min-height: 150px"
                  rows="6"
                ></textarea>
                <mat-hint>Información adicional relevante</mat-hint>
              </mat-form-field>
            </section>
          </div>
        }
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="this.dialog.closeAll()"
          text="Cancelar"
          icon="close"
        ></app-button>
        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  }
</mat-card>
